/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useCallback, useContext, useRef} from 'react';
import {ARMcontext} from '../../../utils/context/context';
import {FluidContainer, TableFreshStrength, TableFreshROM, Radio, Tag, Loader, Modal} from '../../../components';
import {
  RadiosContainer,
  TableWrapper,
  RadiosWrapper,
  ArmRecoveryContainer,
  TextContainer,
  AlertContainer,
  AlertWrapper,
  Oval,
  ExamInfoContainer,
  ExamInfoUnit,
  ExamRadios,
  ArmRecoveryTop,
  ArmRecoveryInfoTitle,
  ArmRecoveryInfoSubtitle,
  ArmRecoveryInfoText,
  ArmRecoveryInfoSpan,
  ArmRecoveryInfoSection,
  ModalBottom,
  ModalBottomLabels,
  ArmRecoveryInfoButton,
} from '../styles';
import {Teams} from '../../../utils/api';
import TablePostStr from '../../../components/Table/TablePostStrength';
import TablePostROM from '../../../components/Table/TablePostROM';
import TablePrimer from '../../../components/Table/TablePrimer';
import {capitalizeFirstLetters} from '../../../utils/hooks/text-formatter';
import {TableColumn, TableRow, TableSubHeader, TableTopHeader, TableUnit, TableHead, TableBody} from '../../../components/Table/styles';
import {ArmRecovery, ArmFatigue, ArmReadiness} from '../../../utils/constants/fatigueZonesInfo';
import PaginationControls from '../../../components/PaginationControls/PaginationControls';
import {useLocation, useNavigate} from 'react-router-dom';
import {CacheKeysTables, KeyExamCache} from '../../../utils/constants/keyCache';
import {getQueryCacheForTable} from '../../../utils/helpers/queryCacheKey';

const Exams = ({isFirstLoad, playersGroup, playerNameSearch, alerts, useDefaultAlerts, useAlerts}) => {
  const navigate = useNavigate();
  let path = useLocation().pathname;
  let initialExam = {fresh: true, post: false, primer: false};
  if (path.includes('post')) initialExam = {fresh: false, post: true, primer: false};
  if (path.includes('primer')) initialExam = {fresh: false, post: false, primer: true};
  let initialSubExam = path.includes('rom') ? {strength: false, rom: true} : {strength: true, rom: false};
  const {selectedTeam, triggerRefresh, setTriggerRefresh} = useContext(ARMcontext);
  const TEAMS = useRef(new Teams()).current;
  const [radioExams, setRadioExams] = useState<any>(initialExam);
  const [radio, setRadio] = useState<any>(initialSubExam);

  const [exams, setExams] = useState([]);
  const [postExams, setPostExams] = useState([]);
  const [primerExams, setPrimerExams] = useState([]);
  const [averageInfo, setAverageInfo] = useState({});
  const [postAverage, setPostAverage] = useState<any>({});
  const [primerAverage, setPrimerAverage] = useState<any>({});
  const [loadingTableStrength, setLoadingTableStrength] = useState(true);
  const [loadingTableFatigue, setLoadingTableFatigue] = useState(true);
  const [loadingTablePrimer, setLoadingTablePrimer] = useState(true);
  const [fatigueModal, setFatigueModal] = useState(false);
  const [modalInfo, setModalInfo] = useState(radioExams.fresh ? ArmRecovery : radioExams.post ? ArmFatigue : ArmReadiness);
  const [selectedTeamId, setSelectedTeamId] = useState(selectedTeam._id);
  const [currentFreshPage, setCurrentFreshPage] = useState(0);
  const [currentPostPage, setCurrentPostPage] = useState(0);
  const [currentPrimerPage, setCurrentPrimerPage] = useState(0);
  const [currentRecordPerPageFresh, setCurrentRecordPerPageFresh] = useState(20);
  const [currentRecordPerPagePost, setCurrentRecordPerPagePost] = useState(20);
  const [currentRecordPerPagePrimer, setCurrentRecordPerPagePrimer] = useState(20);
  const [currentPlayerNameSearch, setCurrentPlayerNameSearch] = useState(playerNameSearch);
  const [currentPlayerGroup, setCurrentPlayerGroup] = useState(playersGroup);

  const [freshPagination, setFreshPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    recordsPerPage: 20,
  });
  const [postPagination, setPostPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    recordsPerPage: 20,
  });
  const [primerPagination, setPrimerPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    recordsPerPage: 20,
  });

  const [sortConfig, setSortConfig] = useState({key: 'date', direction: 'desc'});
  const [currentSortDirection, setCurrentSortDirection] = useState('desc');

  const handleSort = useCallback(key => {
    setSortConfig(prevSort => ({
      key,
      direction: prevSort.key === key && prevSort.direction === 'asc' ? 'desc' : 'asc',
    }));
  }, []);

  const fetchExams = useCallback(
    async (isForcedReload = false) => {
      setLoadingTableStrength(true);
      const isSameTeam = selectedTeamId === selectedTeam._id;
      const isSameCurrentFreshPage = currentFreshPage === freshPagination.currentPage;
      const isSamePlayerNameSearch = currentPlayerNameSearch === playerNameSearch;
      const isSameSortOrder = currentSortDirection === sortConfig.direction;
      const isSameRecordsPerPage = currentRecordPerPageFresh === freshPagination.recordsPerPage;
      const isSamePlayerGroup = currentPlayerGroup === playersGroup;
      try {
        if (
          isSameTeam &&
          isSameCurrentFreshPage &&
          isSamePlayerNameSearch &&
          isSameSortOrder &&
          isSameRecordsPerPage &&
          isSamePlayerGroup &&
          !isForcedReload
        ) {
          return;
        }
        const currentPage = isSameTeam ? (isSamePlayerNameSearch ? freshPagination.currentPage : 1) : 1;
        const currentRecordsPerPage = isSameTeam ? (isSamePlayerNameSearch ? freshPagination.recordsPerPage : 20) : 20;
        const freshExamKey = KeyExamCache.FreshExam;

        const freshExam = getQueryCacheForTable({
          selectedTeam,
          playersGroup,
          page: currentPage,
          recordsPerPage: currentRecordsPerPage,
          sortBy: sortConfig.key,
          sortOrder: sortConfig.direction,
          mainCacheKey: freshExamKey.table,
          playerNameSearch,
        });
        const getExams = await TEAMS.ExecuteCacheRequest({
          isForceDelete: !isSamePlayerNameSearch || isForcedReload,
          cacheKey: freshExam.cacheKey,
          queryFn: () =>
            TEAMS.GetExams(
              selectedTeam._id,
              alerts.value,
              playersGroup,
              currentPage,
              freshPagination.recordsPerPage,
              sortConfig.key,
              sortConfig.direction,
              playerNameSearch,
            ),
        });

        const result = getExams;

        if (result.status && result.data) {
          setExams(result.data.records);
          setFreshPagination(prev => ({
            ...prev,
            currentPage,
            totalPages: result.data.pagination.totalPages,
            totalItems: result.data.pagination.totalItems,
          }));
          setCurrentFreshPage(currentPage);
          setSelectedTeamId(selectedTeam._id);
          setCurrentPlayerNameSearch(playerNameSearch);
          setCurrentSortDirection(sortConfig.direction);
          setCurrentRecordPerPageFresh(currentRecordsPerPage);
          setCurrentPlayerGroup(playersGroup);
        }

        const cacheTeamAvg = CacheKeysTables(freshExamKey.avg, freshExam.secondaryCacheOpts);
        TEAMS.ExecuteCacheRequest({
          isForceDelete: !isSamePlayerNameSearch,
          cacheKey: cacheTeamAvg,
          queryFn: () => TEAMS.GetExamsTeamAverage(selectedTeam._id, playersGroup),
        })
          .then(examAvg => {
            if (examAvg.status && examAvg.data) {
              setAverageInfo(examAvg.data.teamAverage);
            }
          })
          .catch(err => console.error('Failed to fetch team average:', err));
      } catch (error) {
        console.error('Failed to fetch exams:', error);
      } finally {
        setLoadingTableStrength(false);
      }
    },
    [
      selectedTeam._id,
      alerts.value,
      playersGroup,
      freshPagination.currentPage,
      freshPagination.recordsPerPage,
      sortConfig,
      playerNameSearch,
    ],
  );

  const fetchPostExams = useCallback(
    async (isForcedReload = false) => {
      setLoadingTableFatigue(true);
      const isSameTeam = selectedTeamId === selectedTeam._id;
      const isSameCurrentPostPage = currentPostPage === postPagination.currentPage;
      const isSamePlayerNameSearch = currentPlayerNameSearch === playerNameSearch;
      const isSameSortOrder = currentSortDirection === sortConfig.direction;
      const isSameRecordsPerPage = currentRecordPerPagePost === postPagination.recordsPerPage;
      const isSamePlayerGroup = currentPlayerGroup === playersGroup;
      try {
        if (
          isSameTeam &&
          isSameCurrentPostPage &&
          isSamePlayerNameSearch &&
          isSameSortOrder &&
          isSameRecordsPerPage &&
          isSamePlayerGroup &&
          !isForcedReload
        ) {
          return;
        }
        const currentPage = isSameTeam ? (isSamePlayerNameSearch ? postPagination.currentPage : 1) : 1;
        const currentRecordsPerPage = isSameTeam ? (isSamePlayerNameSearch ? postPagination.recordsPerPage : 20) : 20;
        const TeamIdentifier = selectedTeam._id ?? selectedTeam.__name;
        const postExamKey = KeyExamCache.PostExam;
        const secondaryCacheOpts = [TeamIdentifier, `player-group-${playersGroup}`];
        const cacheKey = CacheKeysTables(postExamKey.table, secondaryCacheOpts, {
          page: currentPage,
          recordsPerPage: currentRecordsPerPage,
          sortBy: sortConfig.key,
          sortOrder: sortConfig.direction,
        });
        const getPostExams = await TEAMS.ExecuteCacheRequest({
          isForceDelete: !isSamePlayerNameSearch || isForcedReload,
          cacheKey,
          queryFn: () =>
            TEAMS.GetPostExams(
              selectedTeam._id,
              playersGroup,
              currentPage,
              postPagination.recordsPerPage,
              sortConfig.key,
              sortConfig.direction,
              playerNameSearch,
            ),
        });

        const result = getPostExams;

        if (result.status && result.data) {
          setPostExams(result.data.data.entries);
          setPostPagination(prev => ({
            ...prev,
            currentPage,
            totalPages: result.data.data.pagination.totalPages,
            totalItems: result.data.data.pagination.totalItems,
          }));
          setCurrentPostPage(currentPage);
          setSelectedTeamId(selectedTeam._id);
          setCurrentPlayerNameSearch(playerNameSearch);
          setCurrentSortDirection(sortConfig.direction);
          setCurrentRecordPerPagePost(currentRecordsPerPage);
          setCurrentPlayerGroup(playersGroup);
        }

        const cachePostAvgKey = CacheKeysTables(postExamKey.avg, secondaryCacheOpts);
        TEAMS.ExecuteCacheRequest({
          isForceDelete: !isSamePlayerNameSearch,
          cacheKey: cachePostAvgKey,
          queryFn: () => TEAMS.GetPostExamsTeamAverage(selectedTeam._id, playersGroup),
        })
          .then(averageResult => {
            if (averageResult.status && averageResult.data) {
              setPostAverage(averageResult.data.teamSummary);
            }
          })
          .catch(err => console.error('Failed to fetch post team average:', err));
      } catch (error) {
        console.error('Failed to fetch post exams:', error);
      } finally {
        setLoadingTableFatigue(false);
      }
    },
    [selectedTeam._id, playersGroup, postPagination.currentPage, postPagination.recordsPerPage, sortConfig, playerNameSearch],
  );

  const fetchPrimerExams = useCallback(
    async (isForcedReload = false) => {
      setLoadingTablePrimer(true);
      const isSameTeam = selectedTeamId === selectedTeam._id;
      const isSameCurrentPrimerPage = currentPrimerPage === primerPagination.currentPage;
      const isSamePlayerNameSearch = currentPlayerNameSearch === playerNameSearch;
      const isSameSortOrder = currentSortDirection === sortConfig.direction;
      const isSameRecordsPerPage = currentRecordPerPagePrimer === primerPagination.recordsPerPage;
      const isSamePlayerGroup = currentPlayerGroup === playersGroup;

      try {
        if (
          isSameTeam &&
          isSameCurrentPrimerPage &&
          isSamePlayerNameSearch &&
          isSameSortOrder &&
          isSameRecordsPerPage &&
          isSamePlayerGroup &&
          !isForcedReload
        ) {
          return;
        }
        const currentPage = isSameTeam ? (isSamePlayerNameSearch ? primerPagination.currentPage : 1) : 1;
        const currentRecordsPerPage = isSameTeam ? (isSamePlayerNameSearch ? primerPagination.recordsPerPage : 20) : 20;
        const TeamIdentifier = selectedTeam._id ?? selectedTeam.__name;
        const primerExamKey = KeyExamCache.ArmPrimer;
        const secondaryCacheOpts = [TeamIdentifier, `player-group-${playersGroup}`];
        const cacheKey = CacheKeysTables(primerExamKey.table, secondaryCacheOpts, {
          page: currentPage,
          recordsPerPage: currentRecordsPerPage,
          sortBy: sortConfig.key,
          sortOrder: sortConfig.direction,
        });
        const getPrimerExams = await TEAMS.ExecuteCacheRequest({
          isForceDelete: !isSamePlayerNameSearch || isForcedReload,
          cacheKey,
          queryFn: () =>
            TEAMS.GetPrimerExams(
              selectedTeam._id,
              playersGroup,
              currentPage,
              primerPagination.recordsPerPage,
              sortConfig.key,
              sortConfig.direction,
              playerNameSearch,
            ),
        });

        const result = getPrimerExams;

        if (result.status && result.data) {
          setPrimerExams(result.data.data.entries);
          setPrimerPagination(prev => ({
            ...prev,
            currentPage,
            totalPages: result.data.data.pagination.totalPages,
            totalItems: result.data.data.pagination.totalItems,
          }));
          setCurrentPrimerPage(currentPage);
          setSelectedTeamId(selectedTeam._id);
          setCurrentPlayerNameSearch(playerNameSearch);
          setCurrentSortDirection(sortConfig.direction);
          setCurrentRecordPerPagePrimer(currentRecordsPerPage);
          setCurrentPlayerGroup(playersGroup);
        }

        const cachePrimerAvgKey = CacheKeysTables(primerExamKey.avg, secondaryCacheOpts);
        TEAMS.ExecuteCacheRequest({
          isForceDelete: !isSamePlayerNameSearch,
          cacheKey: cachePrimerAvgKey,
          queryFn: () => TEAMS.GetPrimerExamsTeamAverage(selectedTeam._id, playersGroup),
        })
          .then(averageResult => {
            if (averageResult.status && averageResult.data) {
              setPrimerAverage(averageResult.data.teamSummary);
            }
          })
          .catch(err => console.error('Failed to fetch primer team average:', err));
      } catch (error) {
        console.error('Failed to fetch primer exams:', error);
      } finally {
        setLoadingTablePrimer(false);
      }
    },
    [selectedTeam._id, playersGroup, primerPagination.currentPage, primerPagination.recordsPerPage, sortConfig, playerNameSearch],
  );

  useEffect(() => {
    if (!isFirstLoad || playerNameSearch) {
      if (radioExams.fresh) fetchExams();
      if (radioExams.post) fetchPostExams();
      if (radioExams.primer) fetchPrimerExams();
    }
  }, [isFirstLoad, radioExams, fetchExams, fetchPostExams, fetchPrimerExams, playerNameSearch]);

  useEffect(() => {
    let loc = location.pathname;
    if (loc.substring(loc.length - 5, loc.length) === 'exams') {
      navigate('/players/exams/fresh/strength', {replace: true});
    }
  }, []);

  const reloadingTriggerExams = async () => {
    await fetchExams();
    await fetchPostExams();
    await fetchPrimerExams();
    setTriggerRefresh({
      ...triggerRefresh,
      exams: false,
    });
  };
  useEffect(() => {
    if (triggerRefresh.exams) reloadingTriggerExams();
  }, [triggerRefresh.exams]);

  const HandleRadioExams = useCallback(
    (e: any) => {
      const id = e.target.id;
      if (id === 'fresh') {
        navigate(`/players/exams/fresh/strength`, {replace: true});
        setRadio({strength: true, rom: false});
        setRadioExams({fresh: true, post: false, primer: false});
        setModalInfo(ArmRecovery);
      } else if (id === 'post') {
        navigate(`/players/exams/post/strength`, {replace: true});
        setRadio({strength: true, rom: false});
        setRadioExams({fresh: false, post: true, primer: false});
        setModalInfo(ArmFatigue);
      } else if (id === 'primer') {
        navigate(`/players/exams/primer/strength`, {replace: true});
        setRadio({strength: true, rom: false});
        setRadioExams({fresh: false, post: false, primer: true});
        setModalInfo(ArmReadiness);
      }
    },
    [history],
  );

  const HandleRadioExamTypes = useCallback(
    (e: any) => {
      let lastSlash = String(location.pathname).lastIndexOf('/');
      let root = String(location.pathname).substring(0, lastSlash + 1);
      const id = e.target.id;
      if (id === 'Strength') {
        navigate(`${root}strength`, {replace: true});
        setRadio({strength: true, rom: false});
      } else {
        navigate(`${root}rom`, {replace: true});
        setRadio({strength: false, rom: true});
      }
    },
    [history],
  );

  async function hidePlayer(playerId, action) {
    const response = await TEAMS.HidePlayer(playerId, action);
    if (response.status) {
      await fetchExams(true);
      await fetchPostExams(true);
      await fetchPrimerExams(true);
    }
  }

  function SetModalBottom(info) {
    let rows = Object.entries(info.info.zones);
    return (
      <ModalBottom>
        <ModalBottomLabels>
          {rows.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <Oval size={'8'} color={row[0]} margin={'0px 8px'} />
              {capitalizeFirstLetters(row[0], ' ')}
            </React.Fragment>
          ))}
        </ModalBottomLabels>
        <TableUnit color="black">
          <TableHead>
            <TableRow>
              <TableTopHeader hide={true}></TableTopHeader>
              <TableTopHeader colSpan={5} color="black">
                {String(info.info.title).toUpperCase()}
              </TableTopHeader>
            </TableRow>
            {info.info.categories && (
              <TableRow>
                <TableSubHeader hide={true} border={'none'}></TableSubHeader>
                {info.info.categories.map(category => (
                  <TableSubHeader key={category}>{category}</TableSubHeader>
                ))}
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} bgColor={row[0]}>
                <TableColumn width={'0px'}>
                  <Oval size={'8'} color={row[0]} margin={'0px 8px'} />
                </TableColumn>
                {Object.values(Object(row[1])).map((col, colIndex) => (
                  <TableColumn key={colIndex}>{String(col)}</TableColumn>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </TableUnit>
      </ModalBottom>
    );
  }

  return (
    <FluidContainer overflow>
      <RadiosWrapper>
        <ExamRadios>
          <RadiosContainer onClick={HandleRadioExams} mBottom={'15px'}>
            <Radio
              theme="button"
              title="FRESH EXAM"
              name="radioExams"
              id="fresh"
              checked={radioExams.fresh}
              dynamicActive={radioExams.fresh}
              size={'16px'}
            />
            <Radio
              theme="button"
              title="POST EXAM"
              name="radioExams"
              id="post"
              checked={radioExams.post}
              dynamicActive={radioExams.post}
              size={'16px'}
            />
            <Radio
              theme="button"
              title="ARM PRIMER"
              name="radioExams"
              id="primer"
              checked={radioExams.primer}
              dynamicActive={radioExams.primer}
              size={'16px'}
            />
          </RadiosContainer>
        </ExamRadios>
        <ExamInfoContainer>
          <ArmRecoveryContainer>
            {!(radioExams.post && radio.rom) && (
              <>
                <ArmRecoveryTop>
                  {radio.rom ? (
                    <TextContainer>ROM ALERTS</TextContainer>
                  ) : radioExams.fresh ? (
                    <TextContainer>ARM RECOVERY</TextContainer>
                  ) : radioExams.post ? (
                    <TextContainer>ARM FATIGUE</TextContainer>
                  ) : (
                    <TextContainer>ARM READINESS</TextContainer>
                  )}
                  {!radio.rom && <ArmRecoveryInfoButton onClick={() => setFatigueModal(true)}>i</ArmRecoveryInfoButton>}
                </ArmRecoveryTop>
                <AlertWrapper>
                  <AlertContainer>
                    <Oval size={'8'} color={'watch'} />
                    <span> Watch</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'warning'} />
                    <span> Warning</span>
                  </AlertContainer>
                  <AlertContainer>
                    {!radioExams.post && !radio.rom && (
                      <>
                        <Oval size={'8'} color={'medical'} />
                        <span> Medical</span>
                      </>
                    )}
                  </AlertContainer>
                </AlertWrapper>
              </>
            )}
          </ArmRecoveryContainer>
          {!radioExams.primer && (
            <RadiosContainer onChange={HandleRadioExamTypes}>
              <Radio title={`Strength`} name="radioExam" id={'Strength'} checked={radio.strength} dynamicActive={radio.strength} />
              <Radio title={`Range of motion`} name="radioExam" id={'Range of motion'} checked={radio.rom} dynamicActive={radio.rom} />
            </RadiosContainer>
          )}
          <ExamInfoUnit>
            <span>Unit of measure</span>
            {radio.strength && <Tag name={'Lbs'} theme={'Info'} />}
            {radio.rom && <Tag name={'Degrees'} theme={'Info'} />}
          </ExamInfoUnit>
        </ExamInfoContainer>
      </RadiosWrapper>
      <TableWrapper>
        {radioExams.fresh && (
          <>
            {loadingTableStrength ? (
              <div style={{width: '100%', display: 'block', alignItems: 'center'}}>
                <Loader height="90px" />
              </div>
            ) : (
              <>
                {radio.strength && (
                  <div style={{display: 'flex', flexDirection: 'column'}}>
                    <TableFreshStrength
                      minWidth="1200px"
                      dataTableContent={exams}
                      dataAverage={averageInfo}
                      filter={playerNameSearch}
                      dataCy={'exam-summary-table'}
                      fatigueZone={true}
                      hidePlayer={hidePlayer}
                      handleSort={handleSort}
                      sortBy={sortConfig.key}
                      sortOrder={sortConfig.direction}
                    />
                    <PaginationControls
                      currentPage={freshPagination.currentPage}
                      totalPages={freshPagination.totalPages}
                      totalItems={freshPagination.totalItems}
                      recordsPerPage={freshPagination.recordsPerPage}
                      onPageChange={page => setFreshPagination(prev => ({...prev, currentPage: page}))}
                      onLimitChange={limit => setFreshPagination(prev => ({...prev, recordsPerPage: limit, currentPage: 1}))}
                    />
                  </div>
                )}
                {radio.rom && (
                  <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <TableFreshROM
                      minWidth="1200px"
                      dataTableContent={exams}
                      dataAverage={averageInfo}
                      filter={playerNameSearch}
                      dataCy={'exam-rom-table'}
                      fatigueZone={true}
                      hidePlayer={hidePlayer}
                      handleSort={handleSort}
                      sortBy={sortConfig.key}
                      sortOrder={sortConfig.direction}
                    />
                    <PaginationControls
                      currentPage={freshPagination.currentPage}
                      totalPages={freshPagination.totalPages}
                      totalItems={freshPagination.totalItems}
                      recordsPerPage={freshPagination.recordsPerPage}
                      onPageChange={page => setFreshPagination(prev => ({...prev, currentPage: page}))}
                      onLimitChange={limit => setFreshPagination(prev => ({...prev, recordsPerPage: limit, currentPage: 1}))}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
        {radioExams.post && (
          <>
            {loadingTableFatigue ? (
              <div style={{width: '100%', display: 'block', alignItems: 'center'}}>
                <Loader height="90px" />
              </div>
            ) : (
              <>
                {radio.strength && (
                  <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <TablePostStr
                      minWidth="1200px"
                      dataTableContent={postExams}
                      dataAverage={postAverage}
                      filter={playerNameSearch}
                      dataCy={'exam-summary-table'}
                      fatigueZone={true}
                      hidePlayer={hidePlayer}
                      sortBy={sortConfig.key}
                      sortOrder={sortConfig.direction}
                      handleSort={handleSort}
                    />
                    <PaginationControls
                      currentPage={postPagination.currentPage}
                      totalPages={postPagination.totalPages}
                      totalItems={postPagination.totalItems}
                      recordsPerPage={postPagination.recordsPerPage}
                      onPageChange={page => setPostPagination(prev => ({...prev, currentPage: page}))}
                      onLimitChange={limit => setPostPagination(prev => ({...prev, recordsPerPage: limit, currentPage: 1}))}
                    />
                  </div>
                )}
                {radio.rom && (
                  <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <TablePostROM
                      minWidth="1200px"
                      dataTableContent={postExams}
                      dataAverage={postAverage}
                      filter={playerNameSearch}
                      dataCy={'exam-rom-table'}
                      fatigueZone={false}
                      hidePlayer={hidePlayer}
                      sortBy={sortConfig.key}
                      sortOrder={sortConfig.direction}
                      handleSort={handleSort}
                    />
                    <PaginationControls
                      currentPage={postPagination.currentPage}
                      totalPages={postPagination.totalPages}
                      totalItems={postPagination.totalItems}
                      recordsPerPage={postPagination.recordsPerPage}
                      onPageChange={page => setPostPagination(prev => ({...prev, currentPage: page}))}
                      onLimitChange={limit => setPostPagination(prev => ({...prev, recordsPerPage: limit, currentPage: 1}))}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
        {radioExams.primer && (
          <>
            {loadingTablePrimer ? (
              <div style={{width: '100%', display: 'block', alignItems: 'center'}}>
                <Loader height="90px" />
              </div>
            ) : (
              <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                <TablePrimer
                  minWidth="1200px"
                  dataTableContent={primerExams}
                  dataAverage={primerAverage}
                  filter={playerNameSearch}
                  dataCy={'exam-rom-table'}
                  fatigueZone={true}
                  hidePlayer={hidePlayer}
                  handleSort={handleSort}
                  sortBy={sortConfig.key}
                  sortOrder={sortConfig.direction}
                />
                <PaginationControls
                  currentPage={primerPagination.currentPage}
                  totalPages={primerPagination.totalPages}
                  totalItems={primerPagination.totalItems}
                  recordsPerPage={primerPagination.recordsPerPage}
                  onPageChange={page => setPrimerPagination(prev => ({...prev, currentPage: page}))}
                  onLimitChange={limit => setPrimerPagination(prev => ({...prev, recordsPerPage: limit, currentPage: 1}))}
                />
              </div>
            )}
          </>
        )}
      </TableWrapper>
      {fatigueModal && (
        <Modal active={setFatigueModal} padding={'20px 44px'} maxWidth={'480px'} width={'80vw'} margin={'40px auto'} minWidth={'480px'}>
          {radioExams.fresh && (
            <>
              <ArmRecoveryInfoTitle>ARM RECOVERY</ArmRecoveryInfoTitle>
              <ArmRecoveryInfoSubtitle>Change from average (lbs)</ArmRecoveryInfoSubtitle>
              <ArmRecoveryInfoText>
                A change in your weekly average Fresh exam indicates your throwing arm recovery. Total arm strength decreases need to be
                less than
                <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>and less than<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>
                from average for each individual muscle.
                <br></br>
                <br></br>
                If total strength decreases
                <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>or more or<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>
                or more for each muscle group, you are showing signs that your recovery is less than optimal. Reducing pitch counts,
                pushing bullpens back and lower throwing intensity can help improve recovery.
                <br></br>
                <br></br>
                Recomendations:
                <ArmRecoveryInfoSection>WATCH</ArmRecoveryInfoSection>
                Reduce throwing workloads while you increase strength and evaluate recovery habits.
                <ArmRecoveryInfoSection>WARNING</ArmRecoveryInfoSection>
                Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase strength.
                <ArmRecoveryInfoSection>MEDICAL</ArmRecoveryInfoSection>
                Seek evaluation by a licensed medical professional.
              </ArmRecoveryInfoText>
            </>
          )}
          {radioExams.post && (
            <>
              <ArmRecoveryInfoTitle>ARM FATIGUE</ArmRecoveryInfoTitle>
              <ArmRecoveryInfoText>
                Arm Fatigue is determined by strength evaluations after high intensity throwing days to understand how fatigued your
                throwing arm becomes after games, bullpens, and velocity training days.
                <br></br>
                <br></br>
                The goal is to retain more than
                <ArmRecoveryInfoSpan>{' 90% '}</ArmRecoveryInfoSpan>
                of your strength from Fresh Exams
                <ArmRecoveryInfoSpan>{' (%Fresh) '}</ArmRecoveryInfoSpan>. If you cannot retain
                <ArmRecoveryInfoSpan>{' 90% '}</ArmRecoveryInfoSpan>
                of your Fresh strength, you may need to lower your workload and spend more time building strength and endurance.
                <br></br>
                <br></br>
                Recomendations:
                <ArmRecoveryInfoSection>WATCH</ArmRecoveryInfoSection>
                Reduce throwing workloads for your next high intensity throwing day. For example if strength was not retained on the game
                day, lower pitch counts on your next bullpen/game day/velo day, but maintain strength training.
                <ArmRecoveryInfoSection>WARNING</ArmRecoveryInfoSection>
                Reduce throwing workloads for your next high intensity throwing day. In addition to making adjustments to your next high
                intensity throwing day, you need to focus on recovery habits and strength. It is a good idea after a Warning to make the
                next day a low intensity throwing day or a complete day of rest.
              </ArmRecoveryInfoText>
            </>
          )}
          {radioExams.primer && (
            <>
              <ArmRecoveryInfoTitle>ARM READINESS</ArmRecoveryInfoTitle>
              <ArmRecoveryInfoText>
                A change in daily Arm Primer strength from a <ArmRecoveryInfoSpan>{' 7-day '}</ArmRecoveryInfoSpan>average indicates your
                pre-throwing strength status. Total primer strength decreases need to be less than
                <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>and less than<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>
                from the average for each individual test. If total primer strength decreases
                <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>or more or<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>or
                more for each test, you are showing signs that your pre-throwing strength is less than optimal.
                <br></br>
                <br></br>
                Combined with wellness data, evaluate how the arm feels and also note poor sleep and body soreness in deciding when to
                reduce pitch counts, push bullpens back and lower throwing intensity. Also consider programming adjustments for long-lever
                strength.
                <br></br>
                <br></br>
                Recomendations:
                <ArmRecoveryInfoSection>WATCH</ArmRecoveryInfoSection>
                Reduce throwing workloads while you increase strength and evaluate recovery habits.
                <ArmRecoveryInfoSection>WARNING</ArmRecoveryInfoSection>
                Skip a start, bullpen and high intensity weighted ball programming while training is intensified to increase strength.
                <ArmRecoveryInfoSection>MEDICAL</ArmRecoveryInfoSection>
                Seek evaluation by a licensed medical professional.
              </ArmRecoveryInfoText>
            </>
          )}
          <SetModalBottom info={modalInfo} />
        </Modal>
      )}
    </FluidContainer>
  );
};

export default Exams;
